import * as React from "react";
import { NavLink } from "react-router-dom";
import { renderModuleItem } from "../sidebar/MenuItemComponents";
import { getFirstAvailableSubMenuRoute } from "../../../../utils/navigationUtils";

const UPLOAD_CUSTOMIZE_ALIAS_TO_ROUTE = {
  customize_app_menus: () => "/event/module/event-module-order",
  customize_website_menus: () => "/event/module/eventsite-module-order",
};

const UPLOAD_ALIAS_TO_MODULE_ALIAS = {
  "general-info": "general_info",
  "practical-info": "infobooth",
  "additional-info": "additional_info",
  "information-pages": "information_pages",
  "information_pages": "information_pages",
  directory: "ddirectory",
};

const UploadContentSection = ({
  defaultModuleRoute,
  isParentMenuAvailable,
  getParentMenuSortOrder,
  getParentMenuDisplayNumber,
  isMenuItemAvailable,
  event,
  completed_modules,
  in_array,
  t,
  currentPath,
  menuHierarchy,
}) => {
  const isUploadContentParentAvailable = isParentMenuAvailable("upload_content");

  const firstAvailableRoute = React.useMemo(
    () => getFirstAvailableSubMenuRoute("upload_content", menuHierarchy),
    [menuHierarchy]
  );

  const uploadNode = React.useMemo(
    () => (Array.isArray(menuHierarchy) ? menuHierarchy.find((item) => item.alias === "upload_content") : null),
    [menuHierarchy]
  );

  const visibleChildren = React.useMemo(() => {
    if (!uploadNode || !Array.isArray(uploadNode.children)) return [];
    return [...uploadNode.children]
      .filter((child) => Number(child.status) === 1 && isMenuItemAvailable(child.alias))
      .sort((a, b) => (a.sort_order || 0) - (b.sort_order || 0));
  }, [uploadNode, isMenuItemAvailable]);

  const completedClass = React.useMemo(() => {
    const required = ["attendee", "program", "speaker", "additional-info", "practical-info", "general-info"];
    return required.every((alias) => in_array(alias, completed_modules)) ? "completed" : "";
  }, [completed_modules, in_array]);

  const uploadModulesForRenderer = React.useMemo(() => {
    return visibleChildren
      .filter((child) => child.alias !== "customize_app_menus" && child.alias !== "customize_website_menus")
      .map((child) => {
        const mappedAlias = UPLOAD_ALIAS_TO_MODULE_ALIAS[child.alias] || child.alias;
        return {
          id: child.id,
          alias: mappedAlias,
          status: Number(child.status),
          value: child.name,
          name: child.name
        };
      });
  }, [visibleChildren]);

  if (!isUploadContentParentAvailable) return null;
  
  return (
    <li
      style={{ order: getParentMenuSortOrder("upload_content"), counterSet: `section ${getParentMenuDisplayNumber("upload_content")}` }}
      className={`${window.location.pathname.includes("event/module") ? "bold activeList" : ""} ${completedClass}`}
    >
      <span>
        <NavLink to={firstAvailableRoute || defaultModuleRoute}>{t("M_UPLOAD_CONTENT")}</NavLink>
      </span>
      <ul>
        {visibleChildren
          .filter((child) => child.alias === "customize_app_menus" || child.alias === "customize_website_menus")
          .map((child) => {
          const routeResolver = UPLOAD_CUSTOMIZE_ALIAS_TO_ROUTE[child.alias];
          const route = routeResolver ? routeResolver(event) : null;
          if (!route) return null;
          const lockByApp = child.alias === "customize_app_menus" && Number(event.is_app) === 0;
          const lockByRegistration = child.alias === "customize_website_menus" && Number(event.is_registration) === 0;

          return (
            <li
              key={child.id || child.alias}
              className={lockByApp || lockByRegistration ? "lockscreen" : ""}
            >
              <NavLink to={route}>
                <span>{t(`ED_${child.alias.toUpperCase()}`)}</span>
              </NavLink>
            </li>
          );
        })}
        {uploadModulesForRenderer.map((module, i) =>
          renderModuleItem(module, i, { isMenuItemAvailable, t, event, currentPath, context: "upload_content" })
        )}
      </ul>
    </li>
  );
};

export default UploadContentSection;
